import * as React from 'react';

interface Props {
  to: string;
  children?: React.ReactNode;
}

export const ProductLink: React.FC = (props: Props): JSX.Element => {
  return (
    <a href={props.to}>
      {props.children}
    </a>);
};

